import styled from "styled-components";
import {
  Email,
  Name,
} from "@sonder/ui/source/styled/fragments/UserCardInDropdownItem";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

export const GenericDropdownItem = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  display: flex;
  font-size: 1rem;
  font-family: ${typeface.primary};
  height: 2.85rem;
  outline: none;
  padding: 0 0.75rem;
  text-align: left;
  width: 100%;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    background: ${colors.blueF};
    cursor: pointer;
  }

  &:active:not(:disabled) {
    background: ${colors.blue7};
    border: 1px solid ${colors.blue7};
    color: ${colors.white};

    ${Name}, ${Email} {
      color: ${colors.white};
    }
  }
`;
